import { SSR } from "../../common/apiUrl/ssr/ssrUrl";
import { API } from "../../common/model/objectTypes";
import { inProcessReturnApi } from "../../utils/apiDescription/ssr/inProcessReturns";
import { API_BASE_URL } from "../../utils/constants";
import { commonRequestHeader, commonResponseBody, createCommonJsonResponseWithData, requestHeaderWithCallback } from "../../utils/objectTypeConstants";
import { assignReturnRequestBody, changeDocumentStatusRequestBody, inProcessReturnsRequestParameter, inProcessReturnsResponseBody, secondBaseRequestBody } from "../../utils/ssr/apiObjects";
import { assignReturnJsonRequestCurl, changeDocumentStatusJsonRequestCurl, inProcessReturnJsonRequestCurl, inProcessReturnsJsonRequestCurl } from "../../utils/ssr/sampleJsonRequest";
import { inProcessReturnsJsonResponse } from "../../utils/ssr/sampleJsonResponse";

const Assign : API =  {
    name : "Assign Returns",
    url : `${API_BASE_URL}/${SSR.IN_PROCESS.ASSIGN_RETURNS_URL}`,
    method : "PUT",
    headers : commonRequestHeader,
    apiInfo : inProcessReturnApi.assignReturns,
    requestBody : assignReturnRequestBody,
    responseBody : commonResponseBody,
    jsonRequest : assignReturnJsonRequestCurl,
    jsonResponse : createCommonJsonResponseWithData(200)
}

const ChangeStatus : API = {
    name : "Change Document Status",
    url : `${API_BASE_URL}/${SSR.IN_PROCESS.CHANGE_DOCUMENTS_STATUS_URL}`,
    method : "PUT",
    headers : requestHeaderWithCallback,
    apiInfo : inProcessReturnApi.changeDocumentStatus,
    requestBody : changeDocumentStatusRequestBody,
    responseBody : commonResponseBody,
    jsonRequest : changeDocumentStatusJsonRequestCurl,
    jsonResponse : createCommonJsonResponseWithData(202)
}

const InProcessReturnDEL : API = {
    name : "In Process Return",
    url : `${API_BASE_URL}/${SSR.IN_PROCESS.IN_PROCESS_RETURN_DELETE_URL}`,
    method : "DEL",
    headers : requestHeaderWithCallback,
    apiInfo : inProcessReturnApi.deleteInProcessReturns,
    requestBody : secondBaseRequestBody,
    responseBody : commonResponseBody,
    jsonRequest : inProcessReturnJsonRequestCurl,
    jsonResponse : createCommonJsonResponseWithData(202)
}

const All : API = {
    name : "In Process Returns",
    url : `${API_BASE_URL}/${SSR.IN_PROCESS.IN_PROCESS_RETURNS_URL}`,
    method : "GET",
    headers : commonRequestHeader,
    apiInfo : inProcessReturnApi.getInProcessReturns,
    requestBody : inProcessReturnsRequestParameter,
    responseBody : inProcessReturnsResponseBody,
    jsonRequest : inProcessReturnsJsonRequestCurl,
    jsonResponse : inProcessReturnsJsonResponse
}

export const getContent = (apiName :string) => {    
    switch (apiName) {
        case 'All':
            return All;
        case 'Change Status':
            return ChangeStatus;
        case 'Assign':
            return Assign;
        case 'In Process Return':
            return InProcessReturnDEL;   
    }
}
